import { useEffect } from 'react'
import moment from 'moment'
import { useDispatch } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { PageLoadingSpinner, PrimaryButton, useAdjustPageHeadEntities } from 'ui_kit_qmd'
import { useSelector } from 'store/hooks/useSelector'
import { EventLocations } from 'lib/segment/constants'
import { getIntakeForm } from 'store/charts/ChartsThunk'
import { PROVIDER_EVENT_NAMES, tracking } from 'lib/segment/tracking'
import { QuestionTypeSelector } from './components/question-type-selector'
import { QuestionnaireAnswers } from './components/QuestionnaireAnswers'
import { useGetPatientsPatientIdQuestionnairesSessionId } from 'api/generated/questionnaire/questionnaire'
import { generateLoggIntakeFormData, postHIPAALogMessage } from 'utils/HippaLoggingHelper'
import { QUICK_MD_TITLE_TEXT } from 'utils/constants'
import { IS_INTAKE_QUESTIONS_FORM } from './components/IntakeQuestionsConsttants'
import { safeLocalStorage } from '@quickmd-llc/frontend-utils'
import './IntakeQuestions.scss'
import { formatNameForPatientChartTitle } from '../../helper'
import { PageLayout } from 'components/page-layouts/PageLayout'

const containerStyle = { width: '200px', height: '40px' }

export const IntakeQuestions = () => {
  const location = useLocation()
  const dispatch = useDispatch()

  const searchParams = new URLSearchParams(location.search)
  const patientId = searchParams.get('id')
  const intakeFormId = searchParams.get('intakeFormId')
  // Online/async visits have no intake form; they pass a questionnaire sessionId instead and we
  // render the questionnaire answers from the dedicated endpoint.
  const sessionId = searchParams.get('sessionId')
  const isQuestionnaire = Boolean(sessionId)
  const providerProfile = useSelector((state) => state.waitingRoomReducer.providerProfile)

  // @ts-expect-error TS2538 -- MIGRATION: not approved, fix when encountered
  const patientInfo = useSelector((state) => state.chartsReducer.patientInfo[patientId] || {})
  const loading = useSelector((state) => state.chartsReducer.loading)
  const intakeForm = useSelector((state) => state.chartsReducer.intakeForm)

  const navigate = useNavigate()

  const { data: questionnaireSession, isLoading: isQuestionnaireLoading } =
    useGetPatientsPatientIdQuestionnairesSessionId(patientId || '', sessionId || '', {
      query: { enabled: isQuestionnaire && Boolean(patientId) },
    })

  useEffect(() => {
    tracking.trackEvent(PROVIDER_EVENT_NAMES.VIEW_INTAKE_FORM, {
      // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
      PatientId: patientId,
    })
  }, [patientId])

  useEffect(() => {
    // Intake-form path only; the questionnaire path loads via the questionnaires query hook.
    if (isQuestionnaire) {
      safeLocalStorage.set(IS_INTAKE_QUESTIONS_FORM, 'true')
      return undefined
    }
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    dispatch(getIntakeForm({ patientId, intakeFormId }))
    safeLocalStorage.set(IS_INTAKE_QUESTIONS_FORM, 'true')
    if (patientId && intakeFormId)
      postHIPAALogMessage(
        generateLoggIntakeFormData({
          intakeFormId,
          patientId,
          userId: providerProfile?.ProviderId || '',
        }),
      )
    return () => {
      document.title = QUICK_MD_TITLE_TEXT
    }
  }, [])

  const { FirstName, LastName } = patientInfo || {}
  const pageTitle = `${formatNameForPatientChartTitle(FirstName, LastName)} - Intake Form`
  const pageHeader = useAdjustPageHeadEntities({
    title: pageTitle,
  })

  const { Name, VisitTypeName = '--', CompleteDateTime, Questions = [] } = intakeForm || {}
  const CompleteDate = moment(CompleteDateTime).format('MMM DD YYYY')
  const title = isQuestionnaire ? 'Online visit response' : Name
  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  const breadcrumbs = [
    {
      site: 'Patient charts',
      location: '/patientcharts',
    },
    {
      site: `${patientInfo?.FirstName || ''} ${patientInfo?.LastName || ''}`,
      location: `/patientcharts/patient?id=${patientId}&ref=${EventLocations.intakeForm}`,
    },
    {
      site: `${title || ''}`,
      location: '',
    },
  ]

  const closeIntake = () => navigate(`/patientcharts/patient?id=${patientId}&ref=${EventLocations.intakeForm}`)

  return (
    <PageLayout>
      {loading || isQuestionnaireLoading ?
        <PageLoadingSpinner />
      : null}

      {pageHeader}
      <div className='intake-questions-title-section'>
        <div className='intake-questions-title'>{title}</div>
        <div className='intake-questions-close-button'>
          <PrimaryButton btnText='Close intake' containerStyle={containerStyle} onPress={closeIntake} />
        </div>
      </div>

      <div className='intake-questions-wrap'>
        <div className='intake-questions-container'>
          {isQuestionnaire ?
            <QuestionnaireAnswers session={questionnaireSession} />
          : <div className='intake-questions-table'>
              <div className='intake-questions-item-container'>
                <div className='intake-questions-question'>Completed on: {CompleteDate}</div>
                <div className='intake-questions-answer'>{VisitTypeName}</div>
              </div>
              <hr className='intake-questions-divider' />
              {Questions.map((question, index) => {
                // eslint-disable-next-line react/no-array-index-key -- intake questions are a static, non-reordering list with no stable id
                return <QuestionTypeSelector key={index} question={question} index={index} />
              })}
            </div>
          }
        </div>
      </div>
    </PageLayout>
  )
}
